import React, { Component, useEffect } from "react";
import { Route } from "react-router";
import i18n from "i18next";

//import { Layout } from './components/Layout';
import Home from "./components/Layout/Home/Home";

import EmailTemplates from "./components/Admin/EmailTemplates/EmailTemplates";
import ForgotPassword from "./components/Account/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/Account/ResetPassword/ResetPassword";
import Users from "./components/Admin/Users/Users";
import Logging from "./components/Admin/Logging/Logging";

import Requests from "./components/Sales/Requests/Requests";
import UserProducts from "./components/UserProducts/UserProducts";
import Products from "./components/Sales/Products/Products";

import TermsOfUse from "./components/Layout/TermsOfUse/TermsOfUse";
import Faq from "./components/Layout/Faq/Faq";

import Layout from "./components/Layout/Layout";
import QuickFinder from "./components/QuickFinder/QuickFinder";
import Bedarfe from "./components/Account/Bedarfe/Bedarfe";
import SignIn from "./components/Account/SignIn/SignIn";
import Register from "./components/Account/Register/Register";
import Manage from "./components/Account/Manage/Manage";
import ConfirmEmail from "./components/Account/ConfirmEmail/ConfirmEmail";
import MyTeams from "./components/Account/MyTeams/MyTeams";
import ConfiST from "./components/ConfiST/ConfiST";
import SetLanguage from "./components/Account/Manage/SetLanguage";
import KpiDashboard from "./components/Sales/KpiDashboard/KpiDashboard";
import RoleRequests from "./components/Sales/RoleRequests/RoleRequests";
import About from "./components/Layout/Home/About";
import {
  ApplicationPaths,
  LoginActions,
  LogoutActions,
} from "./components/api-authorization/ApiAuthorizationConstants";
import { baseUrl } from "./helpers/constants";

import "./App.scss";
import Emails from "./components/Sales/Emails/Emails";
import ConfirmNewMail from "./components/Account/ConfirmNewMail/ConfirmNewMail";
import ConfiSTSales from "./components/Sales/Configurator/ConfiStSales";
import OvertakeProductRequests from "./components/Sales/OvertakeProductRequests/OvertakeProductRequests";
import Documents from "./components/Sales/Documents/Documents";
import authService from "./components/api-authorization/AuthorizeService";
import { fetchWrapper } from "./helpers/fetchwrapper";
import { IAppUserDto } from "./Models/IAppUserDto";
import Imprint from "./components/Layout/Imprint/Imprint";
import PrivacyPolicy from "./components/Layout/PrivacyPolicy/PrivacyPolicy";
import Mediathek from "./components/Mediathek/Mediathek";
import AcademyHome from "./components/Academy/AcademyHome";
import AcademyAdminHome from "./components/Academy/AcademyAdminHome";
import AcademyCatalog from "./components/Academy/AcademyCatalog";
import Artikel from "./components/Sales/Artikel/Artikel";
import UserDocuments from "./components/Admin/Users/UserDocuments";
import { Routes } from "react-router-dom";
import Login from "./components/api-authorization/Login";
import { Logout } from "./components/api-authorization/Logout";
import RequireAuth from "./components/api-authorization/RequireAuth";
import AerospaceNorm from "./components/Sales/AerospaceNorm/AerospaceNorm";
import { Text, Link, Button, MessageBar } from "@fluentui/react-components";
import { ArrowDownloadRegular } from "@fluentui/react-icons";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import DocumentAccessLogs from "./components/Admin/DocumentAccessLogs/DocumentAccessLogs";
import { ToastProvider } from "./helpers/ToastProvider";

const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

export default class App extends Component {
  static displayName = App.name;

  componentDidMount() {
    const url = window.location.origin;

    if (!url.includes("localhost") && !url.includes("https")) {
      window.location.href = `https:${url.split(":")[1]}`;
    }

    if (window.location.pathname.toLowerCase() == "/addproduct") {
      // URL zum hinzufügen von Produkten, umleiten zur Partner Lounge oder Toolbox
      authService.getUser().then((user) => {
        if (user) {
          fetchWrapper
            .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
            .then((result: IAppUserDto) => {
              // Bin eingeloggt, wir können die Rollen des Benutzers abfragen:
              fetchWrapper
                .getWithAuth(`${baseUrl}/api/account/getmyroles`)
                .then((roles: string[]) => {
                  if (roles.includes("Partner")) {
                    window.location.href = window.location.href.replace(
                      "/addproduct?",
                      "/partnerlounge?addproduct&"
                    );
                  } else if (roles.includes("Toolbox")) {
                    window.location.href = window.location.href.replace(
                      "/addproduct?",
                      "/mytoolbox?addproduct&"
                    );
                  }
                })
                .catch((error) => {});
            })
            .catch((error) => {});
        }
      });
    }

    if (url.includes("localhost")) {
      document.title = "Lübbering Digital Entwicklungssystem";
    } else if (url.includes("test.luebbering-digital.com")) {
      document.title = "Lübbering Digital Testsystem";
    } else if (url.includes("www.luebbering-digital.com")) {
      document.title = "Lübbering Digital";
    }
  }

  render() {
    const lang = i18n.language.includes("de") ? "de" : "en";

    function openInNewTab(url: string) {
      var win = window.open(url, "_blank");
      win?.focus();
    }

    if (
      isIEOrEdge &&
      window.location.pathname.toLowerCase() != "/account/confirmemail"
    ) {
      return (
        <div className="blockContainerContentCenteredIe lueb-ieMode">
          {lang == "de" && (
            <img
              alt="Home"
              src={`${baseUrl}/IMAGES/HOME_LUEBBERING_DIGITAL_DE.JPG`}
            ></img>
          )}
          {lang == "en" && (
            <img
              alt="Home"
              src={`${baseUrl}/IMAGES/HOME_LUEBBERING_DIGITAL_EN.JPG`}
            ></img>
          )}

          <StackShim style={{ padding: 20 }} tokens={{ childrenGap: 10 }}>
            <h4 style={{ fontFamily: "Arial" }}>
              {i18n.t<string>("browserNotSupportedHeadLine")}
            </h4>
            <Text style={{ fontFamily: "Arial" }}>
              {i18n.t<string>("browserNotSupportedText1")}
            </Text>
            <Text style={{ fontFamily: "Arial" }}>
              {i18n.t<string>("browserNotSupportedText2")}
            </Text>
            <Button
              icon={<ArrowDownloadRegular />}
              onClick={() => {
                openInNewTab("https://www.microsoft.com/edge");
              }}
            >
              Download Microsoft Edge
            </Button>
            <Button
              icon={<ArrowDownloadRegular />}
              onClick={() => {
                openInNewTab("https://www.google.com/chrome/");
              }}
            >
              Download Google Chrome
            </Button>
            <Link
              href={`https://www.luebbering.de/${
                i18n.language.includes("de") ? "de/impressum" : "en/imprint"
              }`}
            >
              {i18n.t<string>("imprint")}
            </Link>
          </StackShim>
        </div>
      );
    } else {
      return (
        <>
          {/* {!baseUrl.includes("www.luebbering-digital.com") && (
            <div style={{ marginTop: 10, zIndex: 1 }}>
              <MessageBar intent="warning">
                ! Testsystem ! Hier kann gefahrlos alles ausprobiert werden!
              </MessageBar>
            </div>
          )} */}
          <ToastProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />

                <Route path="/cis" />
                <Route path="/termsofuse" element={<TermsOfUse />} />
                <Route path="/" element={<Home />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/about" element={<About />} />
                <Route path="/imprint" element={<Imprint />} />
                <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                <Route
                  path="/account/confirmnewmail"
                  element={<ConfirmNewMail />}
                />
                <Route path="/account/login" element={<SignIn />} />
                <Route path="/account/register" element={<Register />} />
                <Route
                  path="/account"
                  element={
                    <RequireAuth>
                      <Manage />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/account/confirmemail"
                  element={<ConfirmEmail />}
                />
                <Route
                  path="/account/forgotpassword"
                  element={<ForgotPassword />}
                />
                <Route
                  path="/account/resetpassword"
                  element={<ResetPassword />}
                />

                <Route
                  path="/mediathek"
                  element={
                    <RequireAuth>
                      <Mediathek />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/language"
                  element={
                    <RequireAuth>
                      <SetLanguage />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/quickfinder"
                  element={
                    <RequireAuth>
                      <QuickFinder />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/mytoolbox"
                  element={
                    <RequireAuth>
                      <UserProducts />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/partnerlounge"
                  element={
                    <RequireAuth>
                      <UserProducts />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/academy"
                  element={
                    <RequireAuth>
                      <AcademyHome />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/academy/catalog"
                  element={
                    <RequireAuth>
                      <AcademyCatalog />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/academyadmin"
                  element={
                    <RequireAuth>
                      <AcademyAdminHome />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/sales/configurator"
                  element={
                    <RequireAuth>
                      <ConfiSTSales />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/sales/requests"
                  element={
                    <RequireAuth>
                      <Requests />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/sales/emails"
                  element={
                    <RequireAuth>
                      <Emails />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/sales/parts"
                  element={
                    <RequireAuth>
                      <Artikel />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/sales/products"
                  element={
                    <RequireAuth>
                      <Products />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/sales/users"
                  element={
                    <RequireAuth>
                      <Users location={window.location} />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/sales/documents"
                  element={
                    <RequireAuth>
                      <Documents />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/sales/AerospaceNorm"
                  element={
                    <RequireAuth>
                      <AerospaceNorm />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/salesadmin/kpi"
                  element={
                    <RequireAuth>
                      <KpiDashboard />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/salesadmin/overtakeproductrequests"
                  element={
                    <RequireAuth>
                      <OvertakeProductRequests />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/sales/RoleRequests"
                  element={
                    <RequireAuth>
                      <RoleRequests />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/account/manage"
                  element={
                    <RequireAuth>
                      <Manage />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/account/myteams"
                  element={
                    <RequireAuth>
                      <MyTeams />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/configuratorst"
                  element={
                    <RequireAuth>
                      <ConfiST />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/sales/usersDocuments"
                  element={
                    <RequireAuth>
                      <UserDocuments />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/account/requirements"
                  element={
                    <RequireAuth>
                      <Bedarfe />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/admin/emailtemplates"
                  element={
                    <RequireAuth>
                      <EmailTemplates />
                    </RequireAuth>
                  }
                />

                {/* <Route
              path="/admin/users"
              element={
                <RequireAuth>
                  <Users location={window.location} />
                </RequireAuth>
              }
            /> */}

                <Route
                  path="/admin/logging"
                  element={
                    <RequireAuth>
                      <Logging />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/admin/documentaccesslogs"
                  element={
                    <RequireAuth>
                      <DocumentAccessLogs />
                    </RequireAuth>
                  }
                />

                <Route
                  path={ApplicationPaths.Login}
                  element={loginAction(LoginActions.Login)}
                />
                <Route
                  path={ApplicationPaths.LoginFailed}
                  element={loginAction(LoginActions.LoginFailed)}
                />
                <Route
                  path={ApplicationPaths.LoginCallback}
                  element={loginAction(LoginActions.LoginCallback)}
                />
                <Route
                  path={ApplicationPaths.Profile}
                  element={loginAction(LoginActions.Profile)}
                />
                <Route
                  path={ApplicationPaths.Register}
                  element={loginAction(LoginActions.Register)}
                />
                <Route
                  path={ApplicationPaths.LogOut}
                  element={logoutAction(LogoutActions.Logout)}
                />
                <Route
                  path={ApplicationPaths.LogOutCallback}
                  element={logoutAction(LogoutActions.LogoutCallback)}
                />
                <Route
                  path={ApplicationPaths.LoggedOut}
                  element={logoutAction(LogoutActions.LoggedOut)}
                />
              </Routes>
            </Layout>
          </ToastProvider>
        </>
      );
    }

    function loginAction(name: string) {
      return <Login action={name}></Login>;
    }

    function logoutAction(name: string) {
      return <Logout action={name}></Logout>;
    }
  }
}
